import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  find,
  getOr,
  kebabCase,
  pipe,
} from 'lodash/fp';
import fetch from 'services/fetch';

// Components
import GeographyHeader from 'components/geographyHeader';
import IndicatorCard from 'components/indicatorCard';

// Selectors
import { allGeographiesSelector } from '../../selectors/basic';

// Styles
import styles from './geography.scss';

const findGeography = (geo) =>
  find(({ geography }) => kebabCase(geography) === geo);

class Geography extends Component {
  componentDidMount() {
    if (0 < this.props.geographyCode.length) {
      this.props.fetchGeography(
        this.props.match.params.category,
        this.props.geographyCode,
      );
      this.props.fetchIndicatorMeta(this.props.match.params.category);
    }
  }

  componentWillReceiveProps(next) {
    if (0 < next.geographyCode.length && (
      (next.geographyCode !== this.props.geographyCode) ||
      (next.match.params.category !== this.props.match.params.category)
    )) {
      this.props.fetchGeography(
        next.match.params.category,
        next.geographyCode
      );
    }
  }

  render() {
    if (this.props.isFetching) {
      return null;
    }

    // Extract values from props.
    const {
      indicators,
      childGeographies = false,
      geography: {
        geography: title,
      } = {},
    } = this.props;
    const parentName = getOr(false)('geography.parent.geography')(this.props);

    return (
      <div className={styles.geography}>
        <div className={styles.wrapper}>
          <GeographyHeader
            childGeographies={childGeographies}
            parentName={parentName}
          />
          <section className={styles.indicatorCards}>
            <h2 className="screen-reader-text">
              Statistics about {title}
            </h2>
            <ul className={styles.indicatorList}>
              {indicators
                .sort(({ index: a }, { index: b }) =>
                  parseInt(a, 10) - parseInt(b, 10))
                .map((indicator) => (
                  <li key={indicator.slug} className={styles.indicatorItem}>
                    <IndicatorCard indicatorData={indicator} />
                  </li>
                ))}
            </ul>
          </section>
        </div>
      </div>
    );
  }
}

Geography.defaultProps = {
  isFetching: false,
  geographyCode: '',
  geography: {},
  indicators: [],
  childGeographies: [],
};

Geography.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      geography: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  fetchGeography: PropTypes.func.isRequired,
  fetchIndicatorMeta: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  geographyCode: PropTypes.string,
  indicators: PropTypes.arrayOf(PropTypes.shape({
    shortTitle: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
      timeframe: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      }).isRequired,
      formattedValue: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
    })).isRequired,
    dataView: PropTypes.string.isRequired,
  })),
  childGeographies: PropTypes.arrayOf(PropTypes.shape({
    geography: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    dataView: PropTypes.string.isRequired,
  })),
  geography: PropTypes.shape({
    geography: PropTypes.string,
    parent: PropTypes.shape({
      geography: PropTypes.string.isRequired,
    }),
  }),
};

// @TODO cleanup these three functions when time is available to do so.
const mapStateToProps = (state) => ({
  isFetching: 0 < state.data.isFetching.length || !state.data.geography,
  ...(state.data.geography || {}),
  allGeographies: allGeographiesSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchGeography: (dataView, geography) =>
    dispatch(fetch.geography(dataView, geography)),
  fetchIndicatorMeta: (category) => dispatch(fetch.indicatorMeta(category)),
});

const mergeProps = (
  { allGeographies, ...state },
  dispatch,
  { match: { params: { category, geography } } }
) => ({
  ...state,
  ...dispatch,
  match: { params: { category, geography } },
  geographyCode: pipe([
    findGeography(geography),
    getOr(geography)('code'),
  ])((allGeographies[category] || {}).byId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Geography);



// WEBPACK FOOTER //
// ./app/components/geography/index.js